
<div class="links-container font-rubik flex flex-col gap-1">
  <a v-if="getSolution('Container Rentals')" class="resources-dropdown-a flex items-center justify-between" :href="getLinkPath('rentals')">
    <span class="underline">Container Rentals</span>
    <img class="h-6" src="@/images/service-area-cards/arrow-outward.svg" alt="Arrow">
  </a>
  <a v-if="getSolution('Container Modifications')" class="resources-dropdown-a flex items-center justify-between" :href="getLinkPath('modifications')">
    <span class="underline">Container Modifications</span>
    <img class="h-6" src="@/images/service-area-cards/arrow-outward.svg" alt="Arrow">
  </a>
  <a v-if="getSolution('Portable Offices')" class="resources-dropdown-a flex items-center justify-between" :href="getLinkPath('portable')">
    <span class="underline">Portable Offices</span>
    <img class="h-6" src="@/images/service-area-cards/arrow-outward.svg" alt="Arrow">
  </a>
</div>
